import React, { Fragment } from 'react';
import classNames from 'classnames';
import { CheckboxRedesign, Comment, ErrorMessage, hoc } from 'src/core';
import {
  CheckboxRadioListItemWrapperRedesign,
  CheckboxRadioListWrapperRedesign
} from '../shared';
import { useCheckboxQuestionRedesignProps } from './checkbox-question-redesign.props';
import styles from './checkbox-question-redesign.module.scss';

/**
 * <CheckboxQuestionRedesign />
 */
const CheckboxQuestionRedesign = hoc(
  useCheckboxQuestionRedesignProps,
  ({
    isBigList,
    isError,
    value,
    question,
    error,
    filteredList,
    commentValues,
    valuesWithComment,
    valuesWithoutComment,
    isLimitElementsMaxError,
    limitElementsMaxMessage,
    imageStyle,
    onCommentChange,
    onCheckboxClick
  }) =>
    value !== 'string' ? (
      <Fragment>
        <CheckboxRadioListWrapperRedesign>
          {filteredList.map(
            ({ text, label, exclusive, comment, imageUrl }, index) => {
              const values = comment ? valuesWithComment : valuesWithoutComment;
              const checked = values.includes(text);

              return (
                <>
                  {!!label ? (
                    <p className={styles.title}>{label}</p>
                  ) : (
                    <CheckboxRadioListItemWrapperRedesign
                      key={index}
                      onCheckboxRadioClick={() =>
                        onCheckboxClick(text, { exclusive, comment })
                      }
                      isImageUrl={filteredList.some(({ imageUrl }) => imageUrl)}
                      commentVal={comment}
                      comment={
                        <React.Fragment>
                          {comment && (
                            <Comment
                              name={text}
                              value={
                                commentValues.find(
                                  ({ answer }) => answer === text
                                )?.comment ?? ''
                              }
                              onChange={event =>
                                onCommentChange(
                                  event.target.name,
                                  event.target.value
                                )
                              }
                              disabled={!checked}
                              placeholder='Вкажіть'
                            />
                          )}
                        </React.Fragment>
                      }
                    >
                      <CheckboxRedesign
                        classes={{
                          flag: classNames(
                            isBigList && styles.checkbox__small_flag
                          ),
                          label: classNames(
                            isBigList && styles.checkbox__small_font
                          )
                        }}
                        question={question}
                        label={text}
                        image={imageUrl}
                        imageStyle={imageStyle}
                        value={checked}
                        onChange={() => {}}
                        isError={isError}
                        error={error}
                      />
                    </CheckboxRadioListItemWrapperRedesign>
                  )}
                </>
              );
            }
          )}
        </CheckboxRadioListWrapperRedesign>
        <ErrorMessage
          isError={isError || isLimitElementsMaxError}
          error={
            isError
              ? error
              : isLimitElementsMaxError
              ? limitElementsMaxMessage
              : error
          }
        />{' '}
      </Fragment>
    ) : null
);

export { CheckboxQuestionRedesign };
